import React from "react";
import TabGroup from "../../componentLibrary/TabGroup";
import ButtonComponents from "./components/ButtonComponents";
import FormComponents from "./components/FormComponents";
import ModalComponents from "./components/ModalComponents";
import Typography from "./components/Typography";
import ContainerComponents from "./components/ContainerComponents";
import FeedbackComponents from "./components/FeedbackComponents";
import NavigationComponents from "./components/NavigationComponents";
import InputComponents from "./components/InputComponents";
import HelpComponents from "./components/HelpComponents";
import ConfirmationBoxComponent from "./components/ConfirmationBoxComponent";
import TagComponents from "./components/TagComponents";

const ComponentLibraryPage = () => {
  const tabs = [
    {
      label: "Typography",
      content: (
        <div className="space-y-6">
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-6">
              <Typography />
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-6">
              <TagComponents />
            </div>
          </div>
        </div>
      ),
    },
    {
      label: "Buttons & Input",
      content: (
        <div className="space-y-6">
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-6">
              <ButtonComponents />
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-6">
              <FormComponents />
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-6">
              <InputComponents />
            </div>
          </div>
        </div>
      ),
    },
    {
      label: "Containers & Navigation",
      content: (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-6">
              <ContainerComponents />
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-6">
              <ModalComponents />
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-6">
              <NavigationComponents />
            </div>
          </div>
        </div>
      ),
    },
    {
      label: "Feedback & Help",
      content: (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-6">
              <FeedbackComponents />
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-6">
              <ConfirmationBoxComponent />
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-6">
              <HelpComponents />
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="py-6">
            <h1 className="text-3xl font-bold text-gray-900">Design System</h1>
            <p className="mt-2 text-gray-600">
              Component library and design tokens
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TabGroup tabs={tabs} variant="contained" />
      </div>
    </div>
  );
};

export default ComponentLibraryPage;
